import {NumberRangeValue, DateRangeType, Dictionary, Nullable} from '@fl/cmsch-fe-library';

/** Criteria form state used by the mating forms. */
export const initialCriterias: Criterias = {
    radios: {},
    dateRanges: {},
    numberRanges: {},
};

/** Criteria groups captured by the mating forms. */
export interface Criterias {
    /** Boolean and radio criteria values. */
    radios: Dictionary<string, Nullable<boolean>>;
    /** Date range criteria values. */
    dateRanges: Dictionary<string, Nullable<DateRangeType>>;
    /** Numeric and percentage criteria values. */
    numberRanges: Dictionary<string, NumberRangeValue>;
}
